jQuery(document).ready(function($) {
    'use strict';

    $('.content-tab').each(function () {

        $(this).on("click", function () {

            var tabClass = $(this).data('id');

            $(this).addClass('active').siblings().removeClass('active');
            $('.tab-content').removeClass('active').addClass('inactive');
            $('.tab-content.' + tabClass).removeClass('inactive').addClass('active');

        });

    });

    $('.tabs-select select').each(function () {

        if( $(this).find('option').length ){

            $(this).on("change", function () {

                $(this).parent().next().children().removeClass('active').addClass('inactive');
                $(this).parent().next().children('.tabs-category[data-id*=' + $(this).find('option:selected').attr('data-id') + ']').addClass('active').removeClass('inactive');

            });

        } else {
            $(this).parent().remove()
        }

    });

    if( $('#testfreaks-badge').length ) {
        MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
        var observer = new MutationObserver(function(mutations, observer) {
            // fired when a mutation occurs
            var stars_html = $('#testfreaks-badge').html();
            if ( $('#testfreaks-badge').children().length > 0 ) {
                $('.testfreaks-stars').html(stars_html);
                $('.woocommerce-tab.product-rating-information').show();
            }
        });
        // define what element should be observed by the observer
        // and what types of mutations trigger the callback
        observer.observe(document.getElementById('testfreaks-badge'), {
            attributes: true
        });
    }
    if( $('#testfreaks-qa').length ) {
        MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
        var observer = new MutationObserver(function(mutations, observer) {
            // fired when a mutation occurs
            var faq_count = $('#testfreaks-qa .tabs .pull-left.tab-txt').text();
            $('.woocommerce-tab.product-faq > h2 span').text(faq_count);
        });
        // define what element should be observed by the observer
        // and what types of mutations trigger the callback
        observer.observe(document.getElementById('testfreaks-qa'), {
            attributes: true
        });
    }

    $('#testfreaks-badge, #testfreaks-qa').addClass('loaded');

});




